import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SoftphoneWidgetComponent } from './softphone-widget/softphone-widget.component';
import { SoftphoneHostComponent } from './softphone-host/softphone-host.component';
import { SoftphoneCallDialogComponent } from './softphone-call-dialog/softphone-call-dialog.component';

@NgModule({
  // TranslateModule (not forRoot) exposes the `translate` pipe to these templates; the
  // TranslateService instance still comes from the app-level TranslateModule.forRoot().
  imports: [CommonModule, MatDialogModule, TranslateModule],
  declarations: [
    SoftphoneWidgetComponent,
    SoftphoneHostComponent,
    SoftphoneCallDialogComponent,
  ],
  exports: [
    SoftphoneWidgetComponent,
    SoftphoneHostComponent,
  ],
})
export class SoftphoneModule { }
